var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMsg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.351,
    height: 36,
    viewBox: "0 0 35.351 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_463",
    "data-name": "Group 463",
    transform: "translate(-68 -212)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_237",
    "data-name": "Group 237",
    transform: "translate(115 389)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1153",
    "data-name": "Path 1153",
    d: "M2.279,1.845H1.194a.109.109,0,1,0,0,.217H2.279a.109.109,0,1,0,0-.217ZM2.5,1.194H.977a.109.109,0,1,0,0,.217H2.5a.109.109,0,1,0,0-.217ZM1.736,0A1.639,1.639,0,0,0,0,1.519,1.454,1.454,0,0,0,.651,2.7v.768l.761-.462a1.991,1.991,0,0,0,.325.027A1.639,1.639,0,0,0,3.472,1.519,1.639,1.639,0,0,0,1.736,0Zm0,2.821a1.756,1.756,0,0,1-.367-.04l-.511.307.007-.5A1.258,1.258,0,0,1,.217,1.519,1.423,1.423,0,0,1,1.736.217a1.423,1.423,0,0,1,1.519,1.3A1.423,1.423,0,0,1,1.736,2.821Z",
    transform: "translate(-42.467 -159.928)",
    fill: "#f6781b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "chat",
    transform: "translate(-47 -177)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_239",
    "data-name": "Group 239",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_238",
    "data-name": "Group 238"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1154",
    "data-name": "Path 1154",
    d: "M21.123,0c-.01.01-.029.01-.058.01A17.661,17.661,0,0,0,7.215,28.676l-2.575,5.98a.96.96,0,0,0,.5,1.264.98.98,0,0,0,.55.068l9.443-1.659a17.017,17.017,0,0,0,5.884,1.022A17.675,17.675,0,0,0,21.123,0Zm-.1,33.431a15.483,15.483,0,0,1-5.45-.993.925.925,0,0,0-.511-.048L7.118,33.778l2.1-4.89a.97.97,0,0,0-.154-1.013,15.42,15.42,0,0,1-2.681-4.456A15.748,15.748,0,1,1,36.8,17.593v.058A15.791,15.791,0,0,1,21.027,33.431Z",
    transform: "translate(-3.366)",
    fill: "#f6781b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_241",
    "data-name": "Group 241",
    transform: "translate(10.735 14.15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_240",
    "data-name": "Group 240"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1155",
    "data-name": "Path 1155",
    d: "M120.839,146.7h-5.209a.965.965,0,1,0,0,1.929h5.209a.965.965,0,1,0,0-1.929Z",
    transform: "translate(-114.666 -146.7)",
    fill: "#003358"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_243",
    "data-name": "Group 243",
    transform: "translate(10.735 18.973)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_242",
    "data-name": "Group 242"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1156",
    "data-name": "Path 1156",
    d: "M127.591,196.7h-11.96a.965.965,0,1,0,0,1.929h11.96a.965.965,0,0,0,0-1.929Z",
    transform: "translate(-114.666 -196.7)",
    fill: "#003358"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMsg);
export default __webpack_public_path__ + "static/media/icon_msg.b05fa0a957e0331328fdeed8a674ee3f.svg";
export { ForwardRef as ReactComponent };